import * as people from '../data/people.js';
import { closeCategories } from '../data/closeCategories.js';

function getBoxState(guess, correctAnswer, key) {
  const guessedPerson = people[guess.toLowerCase()];

  if (key === 'name') return 'blank';

  // If guess is correct, or if it's an array, sort it first then check again
  if (
    guessedPerson[key] === correctAnswer[key] ||
    (Array.isArray(guessedPerson[key]) &&
      Array.isArray(correctAnswer[key]) &&
      guessedPerson[key].sort().join(',') ===
        correctAnswer[key].sort().join(','))
  ) {
    return 'correct';
  }

  // If game list includes crossover
  if (
    key === 'favouriteGames' &&
    Array.isArray(guessedPerson[key]) &&
    guessedPerson[key].some((game) =>
      correctAnswer.favouriteGames.includes(game),
    )
  ) {
    return 'close';
  }

  // If year is within 2 years of the correct answer
  if (
    key === 'year' &&
    Math.abs(guessedPerson[key] - correctAnswer[key]) <= 2
  ) {
    return 'close';
  }

  if (['country', 'hairColour', 'activity'].includes(key)) {
    for (const category of closeCategories[key]) {
      if (
        category.includes(guessedPerson[key]) &&
        category.includes(correctAnswer[key])
      ) {
        return 'close';
      }
    }
  }

  return 'blank';
}

export function generateShareText(
  guesses,
  correctAnswer,
  isWin,
  gameMode = 'person',
) {
  const title =
    gameMode === 'quote'
      ? 'Smackdle Quote'
      : gameMode === 'conversation'
        ? 'Smackdle Conversation'
        : 'Smackdle';

  if (gameMode === 'quote') {
    const guessCount = guesses.filter((g) => g !== null).length;
    const result = isWin
      ? `- ${guessCount} guess${guessCount === 1 ? '' : 'es'}`
      : '- Failed';

    let shareText = `${title} ${result}\n\n`;

    // Add visual representation for quote game
    const validGuesses = guesses.filter((g) => g !== null);
    validGuesses.forEach((guess) => {
      if (guess.toLowerCase() === correctAnswer.toLowerCase()) {
        shareText += '🟩\n';
      } else {
        shareText += '⬛\n';
      }
    });

    shareText += '\n<' + window.location.origin + '>';
    return shareText;
  }

  if (gameMode === 'conversation') {
    const guessCount = guesses.filter((g) => g !== null).length;
    const result = isWin
      ? `- ${guessCount} guess${guessCount === 1 ? '' : 'es'}`
      : '- Failed';

    let shareText = `${title} ${result}\n\n`;

    // Add visual representation for conversation game with two columns
    const validGuesses = guesses.filter((g) => g !== null);

    // Find when each participant was first guessed correctly
    const participant1Index = validGuesses.findIndex(
      (guess) => guess === correctAnswer[0],
    );
    const participant2Index = validGuesses.findIndex(
      (guess) => guess === correctAnswer[1],
    );

    validGuesses.forEach((guess, index) => {
      // Person 1 column: green if this participant was guessed correctly at or before this index
      const person1Green =
        participant1Index !== -1 && index <= participant1Index;

      // Person 2 column: green if this participant was guessed correctly at or before this index
      const person2Green =
        participant2Index !== -1 && index <= participant2Index;

      const person1Symbol = person1Green ? '🟩' : '⬛';
      const person2Symbol = person2Green ? '🟩' : '⬛';

      shareText += person1Symbol + person2Symbol + '\n';
    });

    shareText += '\n<' + window.location.origin + '>';
    return shareText;
  }

  // Original person game logic
  const result = isWin
    ? `- ${guesses.filter((g) => g !== null).length}/5`
    : '- X/5';

  let shareText = `${title} ${result}\n\n`;

  // Add visual representation of guesses
  const validGuesses = guesses.filter((g) => g !== null);
  const attributes = [
    'hairColour',
    'activity',
    'year',
    'invitedBy',
    'favouriteGames',
  ];

  validGuesses.forEach((guess) => {
    if (guess.toLowerCase() === correctAnswer.name.toLowerCase()) {
      shareText += '🟩🟩🟩🟩🟩\n';
    } else {
      let row = '';
      attributes.forEach((attr) => {
        const state = getBoxState(guess, correctAnswer, attr);
        if (state === 'correct') {
          row += '🟩';
        } else if (state === 'close') {
          row += '🟨';
        } else {
          row += '⬛';
        }
      });
      shareText += row + '\n';
    }
  });

  shareText += '\n<' + window.location.origin + '>';

  return shareText;
}

export async function copyToClipboard(text) {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (err) {
    // Fallback for older browsers
    const textArea = document.createElement('textarea');
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.select();
    try {
      document.execCommand('copy');
      document.body.removeChild(textArea);
      return true;
    } catch (fallbackErr) {
      document.body.removeChild(textArea);
      return false;
    }
  }
}
